module.exports = __webpack_public_path__ + "img/pzupanija.5dd1fe4b.png";